import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IPageInfo } from '@iharbeck/ngx-virtual-scroller';
import { CodaltComponent } from '../codalt.component';
import { CustomerProject } from '../customer-project.interface';
import { LocalStorage } from '../local-storage.class';
import { News } from '../models/news.interface';
import { AuthorisationService } from '../services/auth/authorisation.service';
import { Functionalities } from '../services/auth/functionalities';
import { CustomerProjectService } from '../services/customer-project/customer-project.service';
import { NewsService } from '../services/news.service';
import { PageTitleService } from '../services/page-title/page-title.service';
import { SearchService } from '../services/search/search.service';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    standalone: false,
})
export class NewsComponent extends CodaltComponent implements OnInit, OnDestroy {
    @ViewChild('projectFilterSearchTemplate', { static: true }) projectFilterSearchTemplate;

    childActive: boolean = false;

    newsItems: News[] = [];
    loading = true;
    future = false;

    searchProjects: number[] = [];
    projects: CustomerProject[];

    private limit = 9;
    private skip = 0;
    private allLoaded = false;

    constructor(
        private newsService: NewsService,
        private customerProjectService: CustomerProjectService,
        private searchService: SearchService,
        private route: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private pageTitleService: PageTitleService
    ) {
        super();
    }

    ngOnInit(): void {
        this.getPageTitleLabel();
        if (AuthorisationService.hasFunctionality(Functionalities.NewsManagement)) {
            this.customerProjectService.getProjects(true).subscribe(projects => {
                this.projects = projects;
                this.searchService.searchTemplate = this.projectFilterSearchTemplate;
            });
        }
        this.skip = 0;
        this.searchProjects = LocalStorage.getSearchProjectsIds();
        if (this.searchProjects) {
            this.changeSearch();
        } else {
            this.getNews();
        }
    }

    changeSearch() {
        this.skip = 0;
        this.getNews();
        LocalStorage.setSearchProjectsIds(this.searchProjects);
    }

    onChildActivate() {
        this.childActive = true;
        this.cdr.detectChanges();
    }

    onChildDeactivate(event) {
        this.childActive = false;
        this.childClosed(event);
        this.getPageTitleLabel();
        this.cdr.detectChanges();
    }

    childClosed(event) {
        if (event?.reserve) {
            this.skip = 0;
            this.getNews();
        } else if (event?.form) {
            const newsItem = this.newsItems.find(a => a.id === event?.newsItem?.id);
            if (newsItem) {
                Object.assign(newsItem, event?.newsItem);
            } else {
                this.skip = 0;
                this.getNews();
            }
        }
    }

    ngOnDestroy() {
        this.searchService.searchTemplate = null;
        this.subscriptions.unsubscribe();
    }

    scroll(pageInfo: IPageInfo) {
        if (!this.loading && !this.allLoaded) {
            if (pageInfo.endIndex > this.newsItems.length - 3) {
                this.skip += this.limit;
                this.getNews();
            }
        }
    }

    private getNews() {
        this.loading = true;
        this.future = this.route.snapshot.routeConfig?.path === this.Routenames.future;
        this.getPageTitleLabel();
        this.newsService.getList(this.limit, this.skip, this.future, this.searchProjects).subscribe(
            news => {
                if (this.skip === 0) {
                    this.newsItems = [];
                }
                this.allLoaded = news.data.length < this.limit;
                this.newsItems = this.newsItems.concat(news.data);
                this.loading = false;
            },
            () => (this.loading = false)
        );
    }

    private getPageTitleLabel() {
        this.pageTitleService.setTitle(this.future ? 'Toekomstige updates' : 'Updates');
    }
}
